import { PrimitiveUnit } from "./unit.model";

export class LoadingRate {
  value: string;
  metric: PrimitiveUnit;
  other: string;
}
